<template>
  <branding-field
    v-bind="$attrs"
    :border="!hasLogoChosen"
  >
    <div slot="labelsuffix">
      <v-btn
        v-if="hasLogoChosen"
        color="msr"
        flat
        icon
        small
        :title="$t('remove')"
        class="ml-1 mr-0 my-0"
        style="
          min-width: 24px;
          max-width: 24px;
          min-height: 24px;
          max-height: 24px;
        "
        @click="clearLogo()"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </div>
    <v-layout
      slot="field"
      align-center
      class="imagefield-box"
      :style="{'min-height': $attrs['min-height'] || '200px'}"
    >
      <!-- Note: Moving the click handler below to the v-layout above
        would have it behave in an endless loop for some reason, so
        better leave it down there.
      -->
      <v-layout
        column
        class="full-height clickable"
        align-center
        justify-center
        @click="onLogoButtonClicked()"
      >
        <template v-if="!hasLogoChosen">
          <v-icon x-large>
            insert_photo
          </v-icon>
          <div class="mt-2 body-2 grey--text text--darken-2">
            {{ $t('brandingLogoUpload') }}
          </div>
        </template>
        <v-img
          v-if="logoUrl"
          ref="logo"
          contain
          width="100%"
          max-height="300px"
          class="background-checker-pattern outlined--subtle"
          :src="logoUrl"
          @load="onLogoImageLoaded()"
        />
        <div
          v-if="hasLogoChosen && !!width && !!height"
          class="grey--text text--darken-1 caption mt-1 ml-auto"
        >
          {{ width }} x {{ height }} px
        </div>
      </v-layout>
      <!-- Image Upload (invisible, placed here so $refs works with slot) -->
      <image-replacement
        ref="imagereplacement"
        @cropped="onImageChangeConfirmed"
      />
    </v-layout>
  </branding-field>
</template>

<script>
import BrandingField from '@/components/BrandingField';
import ImageReplacement from '@/components/ImageReplacement';

export default {
  components: {
    BrandingField,
    ImageReplacement,
  },
  inheritAttrs: false,
  props: {
    /** Specific to this field type. */
    logo: {
      type: [String, Blob],
      default: null,
    },
  },
  data() {
    return {
      width: null,
      height: null,
    };
  },
  computed: {
    hasLogoChosen() {
      return this.logoUrl !== null;
    },
    /**
     * Handle this.logo being either a URL String or a cropped image Blob.
     */
    logoUrl() {
      if (this.logo === null) {
        return null;
      }
      if (this.logo instanceof Blob) {
        return URL.createObjectURL(this.logo);
      }
      // It's a URL already.
      return this.logo;
    },
  },
  methods: {
    onLogoImageLoaded() {
      const img = this.$refs.logo.image;
      this.width = img.naturalWidth;
      this.height = img.naturalHeight;
    },
    clearLogo() {
      this.$emit('update:logo', null);
    },
    /**
     * Reuse overlayData image replacement by passing a field object.
     */
    onLogoButtonClicked() {
      const opts = {
        field: {
          name: 'logo',
          data: {
            width: 1024,
            height: 1024,
            crop_ratio: 'any',
          },
          value: null,
        },
      };
      this.$refs.imagereplacement.onImageChangeRequested(opts);
    },
    onImageChangeConfirmed(payload) {
      this.$emit('cropped', payload);
    },
  },
};
</script>

<style scoped>
/* https://codepen.io/lloeki/pen/Dvkqw */
.background-checker-pattern {
  background-repeat: repeat;
  background-size: 16px 16px;
  background-position: 0 0, 8px 8px;
  background-image: linear-gradient(
      45deg,
      #d6d6d6 25%,
      transparent 25%,
      transparent 75%,
      #d6d6d6 75%,
      #d6d6d6
    ),
    linear-gradient(
      45deg,
      #d6d6d6 25%,
      transparent 25%,
      transparent 75%,
      #d6d6d6 75%,
      #d6d6d6
    );
}

.imagefield-box {
  border: 1px solid transparent;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandingLogofield.vue